// extracted by mini-css-extract-plugin
export default {"root":"HtmlPreview_root__2SPsT","label":"HtmlPreview_label__cgfU2","frame":"HtmlPreview_frame__jPrFS"};